import React, { useState } from "react"

import View from "./AppButton.js"

const defaultState = {
  modal: { show: false },
  app: { created: false },
}

/**
 * Renders an app button that allows users to create apps
 */
const AppButton = ({ children, ...props }) => {
  // initialize the default state for this buttton
  const [state, setState] = useState(defaultState)
  // helper method for merging old state with new state
  const updateState = (n) => setState((o) => ({ ...o, ...n }))
  // toggles the modal, which allows a user to create credentials
  const toggleModal = () => updateState({ modal: { show: !state.modal.show } })
  // switches the state of this button once an app has been created
  const onCreated = () => updateState({ app: { created: true } })

  return (
    <View
      {...state}
      {...props}
      onToggleModal={toggleModal}
      onCreated={onCreated}
    >
      {children}
    </View>
  )
}

export default AppButton
